"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/Bubble.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Bubble =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Bubble, _Component);

  function Bubble(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.bubbleRef = _react.default.createRef();
    _this.state = {
      bubbleBoundingClientRect: {}
    };
    return _this;
  }

  var _proto = Bubble.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        contentWidth = _this$props.contentWidth,
        contentHeight = _this$props.contentHeight;

    if (!contentWidth || !contentHeight) {
      // if the width or height isn't consistent or can't be provided we calculate it (it's slower)
      this.setState({
        bubbleBoundingClientRect: this.bubbleRef.current.getBoundingClientRect()
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        northSouthLat = _this$props2.northSouthLat,
        eastWestLng = _this$props2.eastWestLng,
        contentHeight = _this$props2.contentHeight,
        contentWidth = _this$props2.contentWidth;

    if ((!contentWidth || !contentHeight) && (prevProps.northSouthLat !== northSouthLat || prevProps.eastWestLng !== eastWestLng)) {
      // if the width or height isn't consistent or can't be provided we calculate it (it's slower)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        bubbleBoundingClientRect: this.bubbleRef.current.getBoundingClientRect()
      });
    }
  };

  _proto.getPositionStyles = function getPositionStyles() {
    var _objectSpread2;

    /* The bubble consists of two elements that need to be positioned: the bubble itself and the
       beak that points to the map marker. This logic determines that positioning.
       
       By default the center of the bubble and beak sit on the map marker center. We position the
       beak so it points the top center of the map marker.
       
       We also move the bubble while keeping the beak centered over
       the map marker when the beak is too close to the horizontal edge of the map.
        When the bubble is too close to the top edge of the map we flip the bubble and point the beak
       upwards.
    */
    var _this$props3 = this.props,
        elementMapPosition = _this$props3.elementMapPosition,
        markerDimensions = _this$props3.markerDimensions,
        contentHeight = _this$props3.contentHeight,
        contentWidth = _this$props3.contentWidth,
        beakWidth = _this$props3.beakWidth,
        beakHeight = _this$props3.beakHeight,
        beakStyle = _this$props3.beakStyle,
        shouldHaveBeak = _this$props3.shouldHaveBeak;
    var bubbleBoundingClientRect = this.state.bubbleBoundingClientRect;
    var markerMapPosition = elementMapPosition;

    if (!markerMapPosition || !markerDimensions) {
      return {
        positionStyle: {},
        beakStyle: {}
      };
    }

    var bubbleHeight = contentHeight || bubbleBoundingClientRect.height;
    var bubbleWidth = contentWidth || bubbleBoundingClientRect.width;
    var screenHalfWidth = (markerMapPosition.left + markerMapPosition.right) / 2;
    var contentHalfWidth = bubbleWidth / 2; // bubbleBuffer adds a visual buffer to the edge of the map for styling so content isn't at the map edge

    var bubbleBuffer;
    var beakHalfWidth = beakWidth / 2; // flip distance markerDimensions is 1.1 so we are a little off the center of the map marker, it's a little cleaner

    var flipDistance = bubbleHeight + beakHeight + markerDimensions.y * 1.1; // default to horizontally centering and putting the card just above the map marker

    var styled = {
      x: markerMapPosition.x,
      y: markerMapPosition.y - (bubbleHeight / 2 + beakHeight + markerDimensions.y / 2)
    }; // since the parent element is horizontally centered on the marker, we put the beak
    // halfway to the right 

    var beakOffSetDirection = 'left';
    var beakOffset = contentHalfWidth - beakHalfWidth; // we have to reposition the bubble when the map marker is within half the content width of the edge

    if (markerMapPosition.left < contentHalfWidth) {
      bubbleBuffer = markerMapPosition.left < beakWidth * 2 ? 0 : 5; // starting with center of card on center of screen: move center of card to left edge,
      // then move center by half width of card so left edge of card is at left edge of screen

      styled.x = -screenHalfWidth + contentHalfWidth + bubbleBuffer; // but keep beak centered on the map marker
      // we round to support fractional map marker widths

      beakOffset = markerMapPosition.left - beakHalfWidth - markerDimensions.x - bubbleBuffer;
    } else if (markerMapPosition.right < contentHalfWidth) {
      bubbleBuffer = markerMapPosition.right < beakWidth * 2 ? 0 : 5;
      styled.x = screenHalfWidth - contentHalfWidth - bubbleBuffer;
      beakOffSetDirection = 'right';
      beakOffset = markerMapPosition.right - beakHalfWidth - markerDimensions.x - bubbleBuffer;
    }

    var beakVerticalPositionBaseline = 'bottom';
    var rotate = '0deg'; // flip bubble below marker when too close to top

    if (markerMapPosition.top < flipDistance) {
      // put card below map marker instead of above
      styled.y += flipDistance; // have beak point up instead of down

      rotate = '180deg'; // put beak on top of card so it stays between card and marker

      beakVerticalPositionBaseline = 'top';
    } // we - 1 for beakVerticalPositionBaseLine so there is no gap between the beak and content


    var beakStyling = shouldHaveBeak ? {
      beakStyle: _objectSpread((_objectSpread2 = {}, _objectSpread2[beakVerticalPositionBaseline] = "-" + (beakHeight - 1) + "px", _objectSpread2[beakOffSetDirection] = beakOffset + "px", _objectSpread2.borderLeft = beakHalfWidth + "px solid transparent", _objectSpread2.borderRight = beakHalfWidth + "px solid transparent", _objectSpread2.borderTop = beakHeight + "px solid white", _objectSpread2.transform = "rotate(" + rotate + ")", _objectSpread2.position = 'absolute', _objectSpread2.width = 0, _objectSpread2.height = 0, _objectSpread2.boxSizing = 'border-box', _objectSpread2.transformOrigin = 'center', _objectSpread2.zIndex = 1, _objectSpread2), beakStyle)
    } : {};
    return _objectSpread({
      bubbleStyle: {
        transform: "translateX(-50%) translateX(" + styled.x + "px) translateY(-50%) translateY(" + styled.y + "px)"
      }
    }, beakStyling);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        children = _this$props4.children,
        shouldHaveBeak = _this$props4.shouldHaveBeak,
        onMapMarkerMouseEnter = _this$props4.onMapMarkerMouseEnter,
        onMapMarkerMouseLeave = _this$props4.onMapMarkerMouseLeave;
    var positions = this.getPositionStyles();
    return _react.default.createElement("div", {
      ref: this.bubbleRef,
      className: "bubble",
      style: positions.bubbleStyle,
      onMouseEnter: onMapMarkerMouseEnter,
      onMouseLeave: onMapMarkerMouseLeave,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166
      },
      __self: this
    }, shouldHaveBeak && _react.default.createElement("div", {
      "data-name": "beak",
      style: positions.beakStyle,
      onMouseEnter: onMapMarkerMouseEnter,
      onMouseLeave: onMapMarkerMouseLeave,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175
      },
      __self: this
    }), children);
  };

  return Bubble;
}(_react.Component);

Bubble.propTypes = process.env.NODE_ENV !== "production" ? {
  /*
      defines the dimensions of the map marker
  */
  markerDimensions: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }).isRequired,

  /*
      defines the position of the map marker, comes from being a child of ZillowMapLayer
  */
  elementMapPosition: _propTypes.default.shape({
    left: _propTypes.default.number,
    right: _propTypes.default.number,
    top: _propTypes.default.number,
    bottom: _propTypes.default.number,
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),

  /*
      used to identify if we are on a different map marker in componentDidUpdate
  */
  northSouthLat: _propTypes.default.number,
  eastWestLng: _propTypes.default.number,

  /*
      defines the height and width of the content to go in the bubble
      if not provided, will work, but it's less efficient
  */
  contentWidth: _propTypes.default.number,
  contentHeight: _propTypes.default.number,

  /*
      defines the beak dimensions
  */
  beakWidth: _propTypes.default.number,
  beakHeight: _propTypes.default.number,

  /*
      display the beak?
  */
  shouldHaveBeak: _propTypes.default.bool,

  /*
      if a user wants to add additional beak syling
  */
  beakStyle: _propTypes.default.shape({}),

  /*
      to continue on hover events from the map marker into the content
  */
  onMapMarkerMouseEnter: _propTypes.default.func,
  onMapMarkerMouseLeave: _propTypes.default.func,

  /*
      The element you want to position
  */
  children: _propTypes.default.node.isRequired
} : {};
Bubble.defaultProps = {
  contentWidth: null,
  contentHeight: null,
  beakWidth: 0,
  beakHeight: 0,
  shouldHaveBeak: true,
  beakStyle: {},
  onMapMarkerMouseEnter: function onMapMarkerMouseEnter() {},
  onMapMarkerMouseLeave: function onMapMarkerMouseLeave() {}
};
var _default = Bubble;
exports.default = _default;